export const FIT_TO_PINS_URL_PARAM = "fitToPins";
